var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#7F7F7F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0l-5.24537e-07,1.24345e-14c-6.62742,2.89694e-07 -12,5.37258 -12,12c2.89694e-07,6.62742 5.37258,12 12,12c6.62742,-2.89694e-07 12,-5.37258 12,-12l2.71279e-07,0.000234894c-0.00758554,-6.62422 -5.37555,-11.9924 -11.9998,-12.0002Zm0,22l-4.37114e-07,-1.06581e-14c-5.52285,-2.41411e-07 -10,-4.47715 -10,-10c2.41411e-07,-5.52285 4.47715,-10 10,-10c5.52285,2.41411e-07 10,4.47715 10,10l7.01811e-08,-6.40904e-05c-0.00602727,5.52033 -4.4796,9.99397 -9.99994,10.0001Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.134,15.81l-4.634,-4.249v-5.061v0c0,-0.552285 -0.447715,-1 -1,-1c-0.552285,0 -1,0.447715 -1,1v5.5l-6.52101e-09,5.95608e-06c-0.000306334,0.280559 0.117259,0.548342 0.324004,0.737998l4.959,4.545l3.3406e-08,3.00447e-08c0.409017,0.367862 1.03721,0.340743 1.413,-0.0610001l2.13445e-08,-2.33332e-08c0.372455,-0.407159 0.344707,-1.03906 -0.0620045,-1.412Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClock);
export default __webpack_public_path__ + "static/media/ic_clock.3348bf585970c3342d6077c9892dc3d3.svg";
export { ForwardRef as ReactComponent };